module.exports = __webpack_public_path__ + "img/202310_07.5ae5365e.jpg";